module.exports = __webpack_public_path__ + "static/media/btn-nav-mobile.9ff64f47.svg";